
 
import React, { Component } from 'react';
import { BounceLoader } from 'react-spinners';
import { Field } from 'redux-form';
import RenderField from '../../common/components/Form/RenderField';
import Button from '../../common/components/Button';
import {
  email,
  phone,
  normalizePhone,
  required,
  validateDob,
  normalizeDob,
  state,
  normalizeZip,
  zipcode,
  noPeriods,
  noSpecialChars,
  getAlphabeticOrder,
  cityMaxLength,
} from '../../common/lib/validation';

import { getError } from '../../common/lib/getError';
import {
  states,
  suffixes,
} from '../../common/lib/generateStates';
import { CITY_HELP_TEXT } from '../../common/lib/constants';

import '../../../style/index.css';
import './migrateExistingUser.css';

class MigrateExistingUserForm extends Component {
  constructor(props) {
    super(props);
    this.resetAutocompleteFn = this.resetAutocompleteFn.bind(this);
  }

  resetAutocompleteFn() {
    const { resetAutocomplete } = this.props;
    resetAutocomplete();
  }

  render() {
    const {
      submitFormFn,
      formSubmissionError,
      errorDetail,
      statusCode,
      migrateProfileFailed,
      isFetching,
      formRef,
    } = this.props;
    return (
      <form
        className="needs-validation"
        noValidate
        ref={formRef}
      >
        <div className="personal-info-wrap">
          <h2 className="form-header">Personal Information</h2>
          <Field
            name="firstName"
            type="text"
            component={RenderField}
            label="Legal First Name*"
            validate={required}
            normalize={noPeriods}
          />
          <Field
            name="middleName"
            type="text"
            component={RenderField}
            label="Middle Name"
            normalize={noPeriods}
          />
          <Field
            name="lastName"
            type="text"
            component={RenderField}
            label="Last Name*"
            validate={required}
            normalize={noPeriods}
          />
          <Field
            name="suffix"
            type="select"
            options={suffixes}
            component={RenderField}
            label="Suffix"
            defaultSelectValue="Select Suffix"
          />
          <Field
            name="streetNumber"
            type="text"
            component={RenderField}
            label="House/Building Number*"
            validate={required}
            placeholder="Ex: 123"
            normalize={noSpecialChars}
          />
          <Field
            name="street"
            type="text"
            component={RenderField}
            label="Street Name*"
            validate={required}
            placeholder="Ex: Main Street"
          />
          <Field
            name="addressLine2"
            type="text"
            component={RenderField}
            label="Apartment/Floor/Other"
            placeholder="Ex: Apartment 2, Floor 3, etc (Optional)"
          />
          <Field
            name="city"
            type="text"
            component={RenderField}
            label="City/Town*"
            validate={[cityMaxLength, required]}
            helpText={CITY_HELP_TEXT}
          />
          <Field
            name="state"
            type="select"
            component={RenderField}
            label="State*"
            options={getAlphabeticOrder(states)}
            validate={state}
            defaultSelectValue="Select State"
          />
          <Field
            name="zip"
            type="text"
            component={RenderField}
            label="Zip Code*"
            validate={zipcode}
            normalize={normalizeZip}
          />
          <Field
            name="phone"
            type="tel"
            component={RenderField}
            label="Phone Number*"
            placeholder="(XXX) XXX-XXXX"
            validate={phone}
            normalize={normalizePhone}
            prepend="phone"
            className="has-prepend"
          />
          <Field
            name="birthdate"
            type="tel"
            component={RenderField}
            label="Date of Birth*"
            normalize={normalizeDob}
            placeholder="MM/DD/YYYY"
            validate={validateDob}
            inputmode="tel"
          />
        </div>
        <div className="personal-info-wrap">
          <h3 className="form-header">Account Setup</h3>
          <Field
            name="email"
            type="text"
            component={RenderField}
            label="Email Address"
            autocorrect="off"
            autocapitalize="none"
            validate={email}
            prepend="mail"
            className="has-prepend"
            fieldId="sso-email"
            disabled
          />
          <div className="button-wrap">
            {isFetching ?
              <div className="loading-wrapper">
                <BounceLoader
                  color="#084267"
                />
              </div>
              :
              <Button
                label="Confirm Details"
                onClickFn={submitFormFn}
                className="nyl-button"
                id="migrate-profile-button"
              />
            }
            {migrateProfileFailed &&
              <p className="submit-error" dangerouslySetInnerHTML={{ __html: getError(errorDetail, statusCode) }} />
            }
            {formSubmissionError &&
              <p className="submit-error">Please see required fields above to continue with your verification.</p>
            }
          </div>
        </div>
      </form>
    );
  }
}

export default MigrateExistingUserForm;
